export var HELP_EVENT_TYPES;
(function (HELP_EVENT_TYPES) {
    HELP_EVENT_TYPES["FlightControlGetTime"] = "Help_Flight_Control_Get_Time";
    HELP_EVENT_TYPES["TicketCreationTime"] = "Help_Ticket_Creation_Time";
    HELP_EVENT_TYPES["ManagementGroupsLoadTime"] = "Help_Management_Groups_Load_Time";
    HELP_EVENT_TYPES["FlightGetTime"] = "Help_Flight_Get_Time";
    HELP_EVENT_TYPES["FlightDeleteTime"] = "Help_Flight_Delete_Time";
    HELP_EVENT_TYPES["ChangeManagementGroupTime"] = "Help_Change_Management_Group_Time";
    HELP_EVENT_TYPES["FlightControlValue"] = "Help_Flight_Control_Value";
})(HELP_EVENT_TYPES || (HELP_EVENT_TYPES = {}));

//# sourceMappingURL=constants.js.map
